/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface State
 */
export interface State {
    /**
     * 
     * @type {string}
     * @memberof State
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    country_id?: string;
}

/**
 * Check if a given object implements the State interface.
 */
export function instanceOfState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StateFromJSON(json: any): State {
    return StateFromJSONTyped(json, false);
}

export function StateFromJSONTyped(json: any, ignoreDiscriminator: boolean): State {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'country_id': !exists(json, 'country_id') ? undefined : json['country_id'],
    };
}

export function StateToJSON(value?: State | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'country_id': value.country_id,
    };
}

